import { Testimonial } from '@rumblefish/ui/src/components/Rumblefish23Theme';

import runeChristensenAvatar from '../../../public/webp/fromPNG/AlgeaTheme/makerDao/rune-christensen-avatar.webp';
import { StyledSection } from './styles';
import { StaticImageData } from 'next/image';

export const TestimonialSection = () => {
  return (
    <StyledSection width="small">
      <Testimonial
        name="Rune Christensen"
        positionInCompany="Founder and CEO of MakerDAO"
        text={`
          Rumble Fish performed beyond our wildest dreams. 
          Their knowledge and expertise allowed us to grow up even faster.
        `}
        avatarSrc={(runeChristensenAvatar as unknown as StaticImageData)?.src}
        customStyles={{
          height: '250px',
          display: 'flex',
          justifyContent: 'center',
        }}
      />
    </StyledSection>
  );
};
